import { graphql } from "relay-runtime"

export const chMedicalReportUploadMutation = graphql`
  mutation chMedicalReportUploadMutation($input: Ch_uploadMedicalReportFilesInput!, $addConnections: [ID!]!) {
    uploadMedicalReportFiles: ch_uploadMedicalReportFiles(input: $input) {
      uploadMedicalReportFilesOutput {
        ... on SuccessUploadMedicalReportFilesOutput {
          attachments @appendNode(connections: $addConnections, edgeTypeName: "ch_ProgressNoteEdge") {
            ...medicalReportAttachmentFragment @relay(mask: false)
          }
        }
        ... on ErrorUploadMedicalReportFilesOutput {
          isSuccess
          error {
            fileName
            message
          }
        }
      }
    }
  }
`
